import React, { ReactNode, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { CloseOutlineIcon } from 'cokitchen-icons';
import { Button, Input, ToastMessage, Textarea } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { cleanObject, getFilterName } from 'utils/functions';

type EditBulkModalProps = {
  show: boolean;
  children?: ReactNode;
  onClose: (refetchData?: boolean) => void;
  data: string[];
  refreshData?: () => void;
  setSelectedBaseAddonCat: (arg0: []) => void;
};
type PayloadType = {
  name: string;
  amount: string;
  images?: string[];
  summary: string;
  soldOut: boolean;
};
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'unset',
    maxWidth: '400px',
    width: '60%'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};

const EditBulkBaseAddonCategory = ({
  show,
  onClose,
  data,
  refreshData,
  setSelectedBaseAddonCat
}: EditBulkModalProps) => {
  const [loading, setLoading] = useState(false);
  const [imageURL, setImageUrl] = useState<string[]>([]);
  const [formData, setFormData] = useState({} as PayloadType);

  const { pathname } = useLocation();

  const editMeal = async () => {
    setLoading(true);
    try {
      const payload = cleanObject({
        base_addon_category_ids: data,
        name: formData.name,
        summary: formData.summary
      });
      const res = await apiService.patch('base-addon-category/bulk/update', {
        data: payload
      });

      if (res?.data) {
        refreshData?.();
        toast(
          <ToastMessage
            type='success'
            message={`Successfully updated ${getFilterName(pathname)}`}
          />
        );
        setSelectedBaseAddonCat([]);
        onClose(true);
        setFormData({} as PayloadType);
        setImageUrl([]);
      }
    } catch {
      toast(<ToastMessage type='error' message={`Error encountered while updating`} />);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (imageURL[0] !== '') setFormData({ ...formData, images: imageURL });
  }, [imageURL]);

  return (
    <div>
      <Modal isOpen={show} style={customStyles} ariaHideApp={false}>
        <div className='pb-8 px-5 space-y-3 text-[#1A1A1A] bg-white rounded-[10px]'>
          <div>
            <div className='flex justify-between items-center border-b border-solid border-[#EFF0F0] py-3 -mx-[1.2rem] '>
              <div></div>
              <h2 className='font-semibold'>Edit Base Addon Category</h2>
              <div className='flex justify-center items-center rounded-full bg-[#EFF0F0] mr-3 w-5 h-5'>
                <CloseOutlineIcon className='cursor-pointer ' onClick={() => onClose()} />
              </div>
            </div>
          </div>

          <div>
            <p className='font-semibold text-[14px] capitalize'>{getFilterName(pathname)} Name</p>
            <Input
              name={`Base meal name`}
              small
              inputClass='h-12 placeholder:text-sm'
              className='text-[14px] '
              placeholder='Enter name'
              value={formData?.name}
              onChange={(e: any) => setFormData({ ...formData, name: e.target.value })}
            />
          </div>

          <div>
            <p className='font-semibold text-[14px] capitalize'>Base addon category summary</p>
            <Textarea
              placeholder='Enter summary'
              className='h-34 placeholder:text-sm'
              value={formData?.summary}
              onChange={(e: any) => setFormData({ ...formData, summary: e.target.value })}
            />
          </div>
          <div className='flex justify-center '>
            <Button
              onClick={editMeal}
              loading={loading}
              className=' h-[40px]'
              color='primary'
              variant='block'>
              Update
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditBulkBaseAddonCategory;
